import {Injectable} from '@nestjs/common';
import { PaymentMode } from '../payment-mode.entity';
import { PaymentModeDTO } from './payment-mode.dto';

@Injectable()
export class PaymentModeAdapter {
    /**
     * 
     * @param PaymentModeDTO 
     * @param isUpdate 
     * @returns 
     */

    public convertDtoToEntity( paymentModeDTO: PaymentModeDTO, isUpdate: boolean = false): PaymentMode {
        const paymentMode = new PaymentMode();
        paymentMode.paymentModeId=paymentModeDTO.paymentModeId;
        paymentMode.paymentMode=paymentModeDTO.paymentMode;
        paymentMode.isActive=paymentModeDTO.isActive==undefined?true:paymentModeDTO.isActive;
        if (isUpdate){
            paymentMode.updatedUser = paymentModeDTO.updatedUser;
        }else {
            paymentMode.isActive = true;
            paymentMode.createdUser=paymentModeDTO.createdUser;
        }
        return paymentMode;
    }
    public convertEntityToDto( paymentModeData: PaymentMode): PaymentModeDTO{
        const paymentMode = new PaymentMode();
        paymentMode.paymentModeId=paymentModeData.paymentModeId;
        paymentMode.paymentMode=paymentModeData.paymentMode;
        paymentMode.isActive=paymentModeData.isActive;
        paymentMode.createdAt=paymentModeData.createdAt;
        paymentMode.createdUser=paymentModeData.createdUser;
        paymentMode.updatedAt=paymentModeData.updatedAt;
        paymentMode.updatedUser=paymentModeData.updatedUser;
        paymentMode.versionFlag=paymentModeData.versionFlag;
        return paymentMode;
    }
}